import { Box, Loader, MantineTheme } from "@mantine/core";

import styles from "./Loading.module.scss";

export interface LoadingRowProps {
    colSpan: number;
}

const boxSx = (theme: MantineTheme) => ({
    borderTopWidth: "1px",
    borderTopStyle: "solid" as const,
    borderTopColor: theme.colorScheme === "dark" ? theme.colors.gray[8] : theme.colors.gray[3],
});

const LoadingRow = ({ colSpan }: LoadingRowProps) => {
    return (
        <Box component="tr" sx={boxSx}>
            <td align="center" className={styles.loadingRow} colSpan={colSpan}>
                <Loader color="blue" variant="dots" />
            </td>
        </Box>
    );
};

export default LoadingRow;
